import { render, staticRenderFns } from "./B1_CompanyPageEU.vue?vue&type=template&id=35db3931&"
import script from "./B1_CompanyPageEU.vue?vue&type=script&lang=js&"
export * from "./B1_CompanyPageEU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports